import { api } from '@/shared/api';

import type { RecommendationsResponse } from './types';

export const recommendationsApi = {
  /**
   * Fetches personalized travel recommendations for the current user.
   * `phone` is the token username field exposed through `useUserStore().user`.
   */
  getRecommendations: (phone: string): Promise<RecommendationsResponse> =>
    api.client
      .get<RecommendationsResponse>(
        `/ranker/recs-travel/${encodeURIComponent(phone)}`,
      )
      .then(response => response.data),
};
